import { log } from "../../util/log";
const SUPPORTED_GAMES = [];
export function addGameEntry(gameEntry) {
    if (gameEntry === undefined) {
        log("error", "unable to add load order page - invalid game entry");
        return;
    }
    const isDuplicate = SUPPORTED_GAMES.find((game) => game.gameId === gameEntry.gameId) !==
        undefined;
    if (isDuplicate) {
        log("debug", "attempted to add duplicate gameEntry to load order extension", gameEntry.gameId);
        return;
    }
    SUPPORTED_GAMES.push(gameEntry);
}
export function findGameEntry(gameId) {
    return SUPPORTED_GAMES.find((game) => game.gameId === gameId);
}
